import {
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    TextField,
    InputAdornment,
    Box,
  } from '@mui/material';
  import {
    Search as SearchIcon,
  } from '@mui/icons-material';
import { usePageTitle } from './PageTitleContext';
import { TabData } from '@/__core/types/TabData';
import AppTabs from '@/__core/components/AppTabs';
import ProfileMenu from '@/modules/users/components/ProfileMenu';

const getSearchPlaceholder = (title: string) => {
  switch (title) {
    case 'Dashboard':
      return 'Search anything...';
    case 'Apps':
      return 'Search apps...';
    case 'Nhân sự':
      return 'Search for name, office, position';
    case 'Tổ chức':
      return 'Search for department, team, role';
    case 'Hợp đồng':
      return 'Search for contract number, employee';
    case 'Careers':
      return 'Search for job title, position';
    case 'Payrolls':
      return 'Search for employee, period';
    default:
      return 'Search anything...';
  }
};

interface HeaderProps {
  // For regular pages (Apps, Settings, Todo, etc.)
  sidebarOpen?: boolean;
  onToggleSidebar?: (open: boolean) => void;
  
  // For modules with tabs
  tabs?: TabData[];
  activeTab?: number;
  currentTabType?: string;
  onTabChange?: (event: React.SyntheticEvent, newValue: number) => void;
  onCloseTab?: (tabId: number) => void;
  onAddTab?: () => void;
  moduleType?: 'users' | 'customers' | 'suppliers' | 'employees' | 'contracts' | 'payrolls' | 'careers' | 'roles' | 'orders' | 'finance' | 'inventory' | 'reports' | 'timekeepings' | 'timesheets';
  showProfile?: boolean;
  hideSearch?: boolean;
}

export default function Header({ 
  sidebarOpen = false, 
  onToggleSidebar = () => {},
  tabs,
  activeTab = 0,
  currentTabType,
  onTabChange,
  onCloseTab,
  onAddTab,
  moduleType = 'users',
  showProfile = true,
  hideSearch = false
}: HeaderProps) {
    const { title } = usePageTitle();

    // If tabs are provided, render ModuleHeader
    if (tabs && onTabChange && onCloseTab && onAddTab) {
      return (
        <Box 
          sx={{
            backgroundColor: '#f8fafc',
            color: '#1e293b',
            boxShadow: 'none',
            borderBottom: '1px solid #e2e8f0',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            px: 2,
            py: 0,
          }}
        >
          <AppTabs
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={onTabChange}
            onCloseTab={onCloseTab}
            onAddTab={onAddTab}
          />

          {/* Right side - Profile Menu */}
          {showProfile && (
            <Box sx={{ pb: 0, display: 'flex', alignItems: 'center' }}>
              <ProfileMenu size="small" />
            </Box>
          )}
        </Box>
      );
    }

    // Otherwise, render regular header
    return (
        <div>
            <AppBar
          position="static"
          sx={{
            backgroundColor: '#f8fafc',
            color: '#1e293b',
            boxShadow: 'none',
            borderBottom: '1px solid #e2e8f0',
          }}
        >
          <Toolbar sx={{ justifyContent: 'space-between' }}>
            {/* Left side - Page Title */}
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {title === 'Apps' ? (
                <>
                  <Typography variant="h6" sx={{ color: '#333', mr: 2, fontWeight: 'bold' }}>
                    XBOX
                  </Typography>
                  
                </>
              ) : (
                <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                  {title}
                </Typography>
              )}
            </Box>

            {/* Right side - Search Bar and Profile Menu */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              {!hideSearch && (
                <TextField
                  placeholder={getSearchPlaceholder(title)}
                  size="small"
                  sx={{
                    minWidth: 300,
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: 'white',
                      '& fieldset': {
                        borderColor: '#e2e8f0',
                      },
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ color: '#64748b' }} />
                      </InputAdornment>
                    ),
                  }}
                />
              )}

              {/* Profile Menu */}
              <ProfileMenu size="small" />
            </Box>
          </Toolbar>
        </AppBar>
        </div>
    )
}
